import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from '@core/scripts/helper/url';
import {useQuery} from '@tanstack/react-query';

const fetchPopularSearches = async () => {
    const absoluteUrl = URL.toAbsolute('/ajax/search/popular/');
    const response = await fetchWithCSRF(absoluteUrl, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch popular searches');
    }

    const popularSearches = await response.json();
    return Array.isArray(popularSearches) ? popularSearches.filter((term) => typeof term === 'string') : [];
};

const usePopularSearches = ({enabled}) => {
    return useQuery({
        queryKey: ['search', 'popular'],
        enabled,
        staleTime: 1000 * 60 * 60,
        queryFn: () => fetchPopularSearches(),
    });
};

export default usePopularSearches;
